"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
/*
 *  Copyright (c) Qwoach LLC 2023. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 16/12/2023
 */

var _require = require("./LogicalSymbols"),
  LogicalSymbols = _require.LogicalSymbols;
var TreeNode = /*#__PURE__*/(0, _createClass2["default"])(function TreeNode(type) {
  var operands = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  (0, _classCallCheck2["default"])(this, TreeNode);
  (0, _defineProperty2["default"])(this, "type", null);
  (0, _defineProperty2["default"])(this, "operands", []);
  this.type = type;
  this.operands = operands;
});
module.exports = /*#__PURE__*/function () {
  function NormalFormManager() {
    (0, _classCallCheck2["default"])(this, NormalFormManager);
  } // this.isDebugEnabled = true
  (0, _createClass2["default"])(NormalFormManager, [{
    key: "convertToDNF",
    value: function convertToDNF(array) {
      var transformConjunctionsCallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (conjunctioins) {
        return conjunctioins;
      };
      // we need to ensure the expression is enclosed in a top level
      // AND operation, so it can be represented as a tree with a single root.
      // This eliminates cases like "(a, b), c"
      array = [LogicalSymbols.AND_START].concat((0, _toConsumableArray2["default"])(array), [LogicalSymbols.AND_END]);
      var tree = this.arrayToTreeNodes(array)[0];
      this.log("NormalForm.convertToDNF: tree = ", tree, ", array = ", array);
      var dnf = this._convertToDNFInternal(tree);
      this.log("NormalForm.convertToDNF: dnf = ", dnf);
      var finalDnf = this.convertDnfToFinalArray(dnf, transformConjunctionsCallback);
      this.log("NormalForm.convertToDNF: finalDnf = ", finalDnf);
      return finalDnf;
    }
  }, {
    key: "convertDnfToFinalArray",
    value: function convertDnfToFinalArray(dnfArray, transformConjunctionsCallback) {
      var array = [];
      array.push(LogicalSymbols.OR_START);
      for (var i = 0; i < dnfArray.length; i++) {
        var conjunctions = transformConjunctionsCallback(dnfArray[i]);
        if (conjunctions.length > 1) {
          array.push(LogicalSymbols.AND_START);
        }
        array.push.apply(array, (0, _toConsumableArray2["default"])(conjunctions));
        if (conjunctions.length > 1) {
          array.push(LogicalSymbols.AND_END);
        }
      }
      array.push(LogicalSymbols.OR_END);
      return array;
    }

    // _convertToCNFInternal(phi) {
    // 	if (this.isVariable(phi)) {
    // 		return [phi];
    // 	} else if (this.isDisjunction(phi)) {
    // 		let operands = phi.operands.map(operand => this._convertToCNFInternal(operand)).reduce((res, node) => res.concat(...node.operands), [])
    // 		return new TreeNode(LogicalSymbols.TYPE_OR, operands)
    // 	} else if (this.isConjunction(phi)) {
    // 		let operands = phi.operands.map(operand => this._convertToCNFInternal(operand)).reduce((res, node) => res.concat(...node.nodes), [])
    // 		return this.distributeOrOverAnd(operands);
    // 	}
    // }
  }, {
    key: "_convertToDNFInternal",
    value: function _convertToDNFInternal(phi) {
      var _this = this;
      // this.log("NormalForm.convertToDNFInternal: phi = ", phi)
      if (this.isVariable(phi)) {
        // this.log("NormalForm.convertToDNFInternal: phi is variable")
        // Base case: φ is a variable
        return [phi];
      } else if (phi.type === LogicalSymbols.TYPE_OR) {
        // Case: φ has the form P v Q
        // this.log("NormalForm.convertToDNFInternal: phi is disjunction")
        var disjuncts = phi.operands.map(function (operand) {
          return _this._convertToDNFInternal(operand);
        });
        this.log("NormalForm.convertToDNFInternal: disjuncts = ", disjuncts);
        return this.flatten(disjuncts);
      } else if (phi.type === LogicalSymbols.TYPE_AND) {
        // Case: φ has the form P ^ Q
        // this.log("NormalForm.convertToDNFInternal: phi is conjunction")
        var conjuncts = phi.operands.map(function (operand) {
          return _this._convertToDNFInternal(operand);
        }).filter(function (arr) {
          return arr.length > 0;
        });
        return this.distributeAndOverOr(conjuncts);
      }
    }
  }, {
    key: "isVariable",
    value: function isVariable(phi) {
      // Check if phi is a variable (literal)
      return !(phi instanceof TreeNode);
    }
  }, {
    key: "isConjunction",
    value: function isConjunction(phi) {
      // Check if phi is a conjunction (P ^ Q)
      return phi instanceof TreeNode && phi.type === LogicalSymbols.TYPE_AND;
    }
  }, {
    key: "isDisjunction",
    value: function isDisjunction(phi) {
      // Check if phi is a disjunction (P v Q)
      return phi instanceof TreeNode && phi.type === LogicalSymbols.TYPE_OR;
    }
  }, {
    key: "flatten",
    value: function flatten(arr) {
      return arr.reduce(function (acc, val) {
        return acc.concat(val);
      }, []);
    }
  }, {
    key: "distributeAndOverOr",
    value: function distributeAndOverOr(lists) {
      // this.log("NormalForm.convertToDNFInternal: distributeAndOverOr: lists = ", lists)
      if (lists.length === 0) {
        return [[]]; // Empty list
      }

      var result = [];
      var rest = this.distributeAndOverOr(lists.slice(1)); // Recursive call for the remaining lists
      var _iterator = _createForOfIteratorHelper(lists[0]),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var value = _step.value;
          // this.log("NormalForm.convertToDNFInternal: distributeAndOverOr: value = ", value)
          if (!Array.isArray(value)) {
            value = [value];
          }
          if (rest.length === 0) {
            result.push((0, _toConsumableArray2["default"])(value));
          } else {
            var _iterator2 = _createForOfIteratorHelper(rest),
              _step2;
            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var r = _step2.value;
                result.push([].concat((0, _toConsumableArray2["default"])(value), (0, _toConsumableArray2["default"])(this.flatten(r))));
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }
          }
        }
        // this.log("NormalForm.convertToDNFInternal: distributeAndOverOr: result = ", result)
        // this.log("NormalForm.convertToDNFInternal: distributeAndOverOr: rest = ", rest)
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return result;
    }
  }, {
    key: "arrayToTreeNodes",
    value: function arrayToTreeNodes(array) {
      var res = [];
      for (var i = 0; i < array.length; i++) {
        var element = array[i];
        if (element === LogicalSymbols.AND_START || element === LogicalSymbols.OR_START) {
          var _treeNode$operands;
          var treeNode = new TreeNode();
          res.push(treeNode);
          var subArray = this.findOperand(array, i);
          treeNode.type = element === LogicalSymbols.AND_START ? LogicalSymbols.TYPE_AND : LogicalSymbols.TYPE_OR;
          (_treeNode$operands = treeNode.operands).push.apply(_treeNode$operands, (0, _toConsumableArray2["default"])(this.arrayToTreeNodes(subArray)));
          i += subArray.length + 1;
        } else {
          res.push(element);
        }
      }
      return res;
    }
  }, {
    key: "findOperand",
    value: function findOperand(array, startIndex) {
      var element = array[startIndex];
      var j;
      var closingSymbol = element === LogicalSymbols.AND_START ? LogicalSymbols.AND_END : LogicalSymbols.OR_END;
      var level = 0;
      j = startIndex + 1;
      while (level !== 0 || array[j] !== closingSymbol) {
        if (array[j] === element) {
          level++;
        } else if (array[j] === closingSymbol) {
          level--;
        }
        j++;
      }
      return array.slice(startIndex + 1, j);
    }
  }, {
    key: "log",
    value: function log() {
      if (this.isDebugEnabled) {
        var _console;
        (_console = console).log.apply(_console, arguments);
      }
    }
  }, {
    key: "logWarn",
    value: function logWarn() {
      if (this.isDebugEnabled) {
        var _console2;
        (_console2 = console).warn.apply(_console2, arguments);
      }
    }
  }]);
  return NormalFormManager;
}();